
<div class="setting-item">
  <h3 class="title">{{title}}</h3>
  <slot></slot>
</div>
